// extracted by mini-css-extract-plugin
export default {"h":"styles_h__oXeLO","p":"styles_p__MGmWl","box":"styles_box__dIRbT"};